import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { JobsidepreviewService } from '../../Services/jobsidepreview.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';

declare var $: any;

@Component({
  selector: 'app-partial-apply',
  standalone: true,
  imports: [TranslateModule,CommonModule],
  templateUrl: './partial-apply.component.html',
  styleUrl: './partial-apply.component.scss'
})
export class PartialApplyComponent {
    constructor(
      private jobsidepreviewservice: JobsidepreviewService,
      private translate: TranslateService,
      private tgSettingsService: TgSettingsService,
      private sanitizer: DomSanitizer,
      private cdr: ChangeDetectorRef
    ) { }

    partialApplyQuestions: any = '';
    encryptedBruid: any = '';
    tgSettings: any;
    PartialApplyParams: {
      jobid: any;
      gqid: any;
      localeid: any;
      partnerId: any;
      siteId: any;
    } = { jobid: null, gqid: null, localeid: null, partnerId: null, siteId: null };
    bLoggedIn:boolean=false;
    Applied:boolean=false;
    jobDetailFields: any;
    solarErrorOccurred:boolean=false;
    ApplyDifference:number=0;
    workFlow:any;
    showjobdetails:boolean=false;
    EnablePartialApplyQuestions:string='';
    bJobDetailsShown:boolean=false;
    page:any;
    bJobDetailsNextToSearchResultsShown:boolean=false;
    


    @Input() set getPartialApplyParams(val: any) {
        if (val) {
            this.PartialApplyParams = val;
            this.showjobdetails=val.showjobdetails;
            this.bLoggedIn=val.bLoggedIn;
            this.Applied=val.Applied;
            this.jobDetailFields=val.jobDetailFields;
            this.solarErrorOccurred=val.solarErrorOccurred;
            this.EnablePartialApplyQuestions=val.EnablePartialApplyQuestions;
            this.bJobDetailsShown=val.bJobDetailsShown;
            this.bJobDetailsNextToSearchResultsShown=val.showjobdetailsnexttosearchresults;
            if(this.PartialApplyParams.jobid && this.PartialApplyParams.gqid && this.PartialApplyParams.localeid){
                this.getPartialApplyQuestions(this.PartialApplyParams.jobid, this.PartialApplyParams.gqid, this.PartialApplyParams.localeid);
            }
        }

    }
    ngOnInit() {
          this.tgSettings = this.tgSettingsService.getCurrentSettings()?.tgSettings;

      
    }
    // showJobDetails(){
      
    // }
    ngAfterViewInit() {
      setTimeout(() => {
        this.page = (window as any).applyScope?.page || (window as any).appScope?.page;
        if (typeof (window as any).appScope?.$apply === 'function') {
          (window as any).appScope.$apply();
        }
      }, 5000);
    }


    // getPartialApplyQuestions(jobid:any,gqid:any,localeid:any) {
    //     const appScope = (window as any).appScope;
    //     const applyScope = (window as any).applyScope;
    //     var rft = (document.getElementById("__RequestVerificationToken") as HTMLInputElement)?.value || '';
    //     var src = (document.getElementById("SrcValue") as HTMLInputElement)?.value || '';
    //     var aipid = '';
    //     if (applyScope !== undefined) {
    //         // False branch must use applyScope (not appScope) — matches search.js exactly
    //         aipid = (applyScope?.page?.aipid === '-1' ? appScope?.oHistory?.Applypage?.applyPageData?.ApidId : applyScope?.page?.aipid) || '';
    //     }
    //     this.partialApplyQuestions = '';

    //     const partialApplyQuestions = $(".partialApplyQuestions");
    //     const applyBtn = $("#applyFromDetailBtnSlide");

    //     partialApplyQuestions.css("display", "none");
    //     applyBtn.css("display", "none");
    //     this.encryptedBruid = appScope?.encryptedBruid != null ? appScope?.encryptedBruid : "";
    //     this.jobsidepreviewservice.getPartialApplyQuestions({
    //         bruid: this.encryptedBruid,
    //         tqid: gqid || '',
    //         localeid: localeid || '',
    //         reqid: jobid || '',
    //         ClientID: this.PartialApplyParams.partnerId || '',
    //         siteid: this.PartialApplyParams.siteId || '',
    //         Src: src,
    //         wbmode: false,
    //         loadingViaAjax: true,
    //         RFT: rft,
    //         SID: (document.getElementById("CookieValue") as HTMLInputElement)?.value || '',
    //         aipid: aipid
    //     }).subscribe({
    //         next: (result: any) => {
    //             if (result && result !== '') {
    //                 this.workFlow = 'jobdetails';
    //                 this.partialApplyQuestions = result;
    //                 if (appScope && typeof appScope.$apply === 'function') {
    //                     appScope.$apply();
    //                 }
    //                 this.cdr.detectChanges();
    //                 const partialApplyDom = document.getElementById("partialApplyDom");
    //                 if (partialApplyDom) {
    //                     partialApplyDom.innerHTML = result;
    //                     const angular = (window as any).angular;
    //                         if (angular) {
    //                             const $compile = angular.element(partialApplyDom).injector()?.get('$compile');
    //                             const $scope = angular.element(partialApplyDom).scope() || appScope;
    //                             if ($compile && $scope) {
    //                                 $compile(partialApplyDom)($scope);
    //                                 if (typeof $scope?.$apply === 'function') {
    //                                     $scope.$apply();
    //                                 }
    //                             } else if (appScope && typeof appScope.$apply === 'function') {
    //                                 appScope.$apply();
    //                             }
    //                         } else if (appScope && typeof appScope.$apply === 'function') {
    //                             appScope.$apply();
    //                         }
    //                 }
    //                 const applyFromDetailBtnSlide = document.getElementById("applyFromDetailBtnSlide");
    //                 const partialApplyQuestions = document.querySelectorAll(".partialApplyQuestions") as NodeListOf<HTMLElement>;
    //                 const partialApplyWidgetEl = PartialApplyWidget[0];



    //                 if (window.innerWidth > 750) {

    //                     const applyBtn = $("#applyFromDetailBtnSlide");
    //                     const partialApplyQuestions = $(".partialApplyQuestions");

    //                     applyBtn.css({display: "block",position: "fixed"}).animate(
    //                         {
    //                             right: `${partialApplyQuestions.width() - applyBtn.height()}px`
    //                         },
    //                         400,
    //                         "easeInSine"
    //                         );

    //                     partialApplyQuestions.css("display", "block").delay(100)
    //                         .animate(
    //                         {
    //                             right: "0px"
    //                         },
    //                         500,
    //                         "easeInSine"
    //                         );

    //                 $("#PartialApplyQuestions").trigger("focus");

    //                 applyBtn.attr({
    //                     "aria-expanded": "true",
    //                     "aria-controls": "PartialApplyQuestions"
    //                 });

    //                 } else {

    //                     $("#applyFromDetailBtnSlide")
    //                         .css({
    //                         display: "block",
    //                         bottom: ""
    //                         });

    //                 }

    //                 if (this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() === "yes") {                   
    //                     $(".searchEnhancedQuickApply").css("display", "inline-block");

    //                     $("#EnhancedapplyFromDetailBtnSlide").attr({
    //                         "aria-expanded": "true",
    //                         "aria-controls": "PartialApplyQuestions"
    //                     });
    //                 }
                   
    //             } else {
    //                 // Server returned empty — revert the button so Angular's *ngIf can control it naturally
    //                 const applyFromDetailBtnSlide = document.getElementById("applyFromDetailBtnSlide");
    //                 applyFromDetailBtnSlide?.style.removeProperty("display");
    //             }
    //         },
    //         error: () => {
    //             // Revert display:none so Angular's *ngIf controls button visibility
    //             const applyFromDetailBtnSlide = document.getElementById("applyFromDetailBtnSlide");
    //             applyFromDetailBtnSlide?.style.removeProperty("display");
    //         }
    //     });
    // }

   // declare const $: any;

    getPartialApplyQuestions(
  jobId: string,
  gqId: string,
  localeId: string
): void {

  const appScope = (window as any).appScope;
  const applyScope = (window as any).applyScope;

  const rft =
    (document.getElementById('__RequestVerificationToken') as HTMLInputElement)?.value ?? '';

  const src =
    (document.getElementById('SrcValue') as HTMLInputElement)?.value ?? '';

  const sid =
    (document.getElementById('CookieValue') as HTMLInputElement)?.value ?? '';

  const aipid =
    applyScope?.page?.aipid === '-1'
      ? appScope?.oHistory?.Applypage?.applyPageData?.ApidId
      : applyScope?.page?.aipid;

  this.partialApplyQuestions = '';

  const $applyBtn = $('#applyFromDetailBtnSlide');
  //const $partialQuestions = $('.partialApplyQuestions');

  $applyBtn.hide();
 // $partialQuestions.hide();

  this.encryptedBruid = appScope?.encryptedBruid ?? '';

  this.jobsidepreviewservice
    .getPartialApplyQuestions({
      bruid: this.encryptedBruid,
      tqid: gqId,
      localeid: localeId,
      reqid: jobId,
      ClientID: this.PartialApplyParams.partnerId,
      siteid: this.PartialApplyParams.siteId,
      Src: src,
      wbmode: false,
      loadingViaAjax: true,
      RFT: rft,
      SID: sid,
      aipid
    })
    .subscribe({

      next: (result: string) => {

        if (!result) {
          return;
        }

        this.workFlow = 'jobdetails';

        this.partialApplyQuestions = result;

        this.cdr.detectChanges();
                    document.querySelectorAll<HTMLElement>('.partialApplyQuestions').forEach(el => el.style.removeProperty('display'));
                    const partialApplyDom = document.getElementById("partialApplyDom");
                    if (partialApplyDom) {
                        partialApplyDom.innerHTML = result;
                        const angular = (window as any).angular;
                            if (angular) {
                                const $compile = angular.element(partialApplyDom).injector()?.get('$compile');
                                const $scope = angular.element(partialApplyDom).scope() || appScope;
                                if ($compile && $scope) {
                                    $compile(partialApplyDom)($scope);
                                    if (typeof $scope?.$apply === 'function') {
                                        $scope.$apply();
                                    }
                                } else if (appScope && typeof appScope.$apply === 'function') {
                                    appScope.$apply();
                                }
                            } else if (appScope && typeof appScope.$apply === 'function') {
                                appScope.$apply();
                            }
                    }

        setTimeout(() => {

    const $applyBtn = $("#applyFromDetailBtnSlide");
    const $partialQuestions = $(".partialApplyQuestions");


    if (window.innerWidth > 750) {

        $applyBtn
            .css({
                display: "block",
                position: "fixed"
            })
            .animate(
                {
                    right: `${$partialQuestions.width() - $applyBtn.height()}px`
                },
                400,
                "easeInSine"
            );

        $partialQuestions.stop(true, false).show();

        setTimeout(() => {
            $partialQuestions.stop(true, false).animate({ right: "0px" }, 500, "easeInSine");
        }, 100);

        $("#PartialApplyQuestions").trigger("focus");

        $applyBtn.attr({
            "aria-expanded": "true",
            "aria-controls": "PartialApplyQuestions"
        });

    } else {

        $applyBtn.css({
            display: "block",
            bottom: ""
        });

    }

    if (
        this.tgSettings?.DisplayJobDetailsNextToSearchResults?.toLowerCase() === "yes"
    ) {

        $(".searchEnhancedQuickApply").css(
            "display",
            "inline-block"
        );

        $("#EnhancedapplyFromDetailBtnSlide").attr({
            "aria-expanded": "true",
            "aria-controls": "PartialApplyQuestions"
        });

    }

}, 5);

      },

      error: error => {
        console.error(error);
      }

    });

}
    SlidePartialApplyQues () {
    var ele = $(".partialApplyQuestions");
    if (ele.css("display") === "none") {
        if (this.tgSettings?.['DisplayJobDetailsNextToSearchResults'] != 'undefined' && this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() != 'yes') {
            $("#applyFromDetailBtnSlide").css({ position: "fixed" })
                .animate(
                    { right: $(".partialApplyQuestions").width() - $("#applyFromDetailBtnSlide").height() + "px" },
                    400,
                    "easeInSine"
                );
            $("#applyFromDetailBtnSlide").css('bottom', '');
            $("#applyFromDetailBtnSlide").attr({
                "aria-expanded": "true", "aria-controls": "PartialApplyQuestions"
            });
        }
        else {
            $("#EnhancedapplyFromDetailBtnSlide").attr({
                "aria-expanded": "true", "aria-controls": "PartialApplyQuestions"
            });
            $("#EnhancedapplyFromDetailBtnSlide").css("right","-400px");
        }


        ele.css("display", "block");
        ele.focus();
        $(".partialApplyQuestions").delay(100).animate({ right: "0px" }, 500, "easeInSine");

    }
    else {
        $(".partialApplyQuestions").animate({ right: -$(".partialApplyQuestions").width() + "px" }, 500, "easeInSine",
            function () {
                ele.css("display", "none");
            }
        );
        if (window.innerWidth > 750) {
            $("#applyFromDetailBtnSlide").animate({ right: "-" + $("#applyFromDetailBtnSlide").height() + "px" }, 400, "easeInSine");
            $("#applyFromDetailBtnSlide").attr({ "aria-expanded": "false", "aria-controls": "PartialApplyQuestions" });
        }
        else {
            $("#applyFromDetailBtnSlide").css({ display: "block", position: "fixed" })
                .animate(
                    { right: "-40px" },
                    400,
                    "easeInSine"
                );
            $("#applyFromDetailBtnSlide").attr({ "aria-expanded": "false", "aria-controls": "PartialApplyQuestions" });

        }
        if (this.tgSettings?.['DisplayJobDetailsNextToSearchResults']?.toLowerCase() != 'yes') {
            const offset = $(".nextJobDetailsCard ").offset();
            const height = $(".nextJobDetailsCard ").outerHeight(true);
            if (offset != undefined && offset.top != undefined && height != undefined) {
                if (window.innerWidth > 750) {
                    var topVal = offset.top + height + 41 + "px";
                    $("#applyFromDetailBtnSlide").css({ position: "absolute", top: topVal })
                }
                $("#applyFromDetailBtnSlide").attr({ "aria-expanded": "false", "aria-controls": "PartialApplyQuestions" });
            }
        }
        else {
            $("#EnhancedapplyFromDetailBtnSlide").attr({
                "aria-expanded": "false", "aria-controls": "PartialApplyQuestions"
            });
        }

    }

}


}
